import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../../types';
import { UserResponseTypeEnum } from '../../openapi/yenta';
import { getLoginURLWithRedirection } from '../../utils/UrlUtils';
import HomeRoute from '../Helmet/HomeRoute';

interface ProtectedRouteProps {
  children: React.ReactNode;
  condition?: boolean;
  pageTitle?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  pageTitle,
}) => {
  const {
    auth: { authUserDetail, keymakerCurrentUser },
  } = useSelector((state: RootState) => state);

  const isAgent = authUserDetail?.type === UserResponseTypeEnum.Agent;

  if (!authUserDetail) {
    // We don't know if it's an agent yet, so default to regular login
    return <Navigate to={getLoginURLWithRedirection()} />;
  }

  if (keymakerCurrentUser?.userBlockedUntilEmailVerified) {
    return <Navigate to={isAgent ? '/agent-verify-email' : '/verify-email'} />;
  }

  if (keymakerCurrentUser?.forceMfa && !keymakerCurrentUser?.mfaType) {
    return <Navigate to={isAgent ? '/agent-enable-mfa' : '/enable-mfa'} />;
  }

  return <HomeRoute title={pageTitle}>{children}</HomeRoute>;
};

export default ProtectedRoute;
